import { Component, ElementRef, Input, OnDestroy, OnInit } from "@angular/core";
import { UntypedFormBuilder, UntypedFormGroup, Validators } from "@angular/forms";
import { NgbActiveModal } from "@ng-bootstrap/ng-bootstrap";
import { TranslateService } from "@ngx-translate/core";
import { Subscription } from "rxjs";
import Editor from "src/assets/ckeditor5-41.3.0/build/ckeditor";
import { AcessoRemotoService } from "src/app/services/acesso-remoto.service";
import { ToastrService } from "ngx-toastr";
import { environment } from "src/environments/environment";

@Component({
  selector: "app-modal-avaliacao-acesso-remoto",
  templateUrl: "./modal-avaliacao-acesso-remoto.component.html",
  styleUrls: ["./modal-avaliacao-acesso-remoto.component.scss"],
})
export class ModalAvaliacaoAcessoRemotoComponent implements OnInit, OnDestroy {
  @Input() dispositivo: any;

  avaliacaoForm: UntypedFormGroup;
  public Editor = Editor;
  public editorConfig: any;
  selector: string;
  newSubs: Subscription;
  isSaving: boolean = false;

  opcoesAvaliacao = [
    "AVALIACAO_ACESSO_REMOTO_OPCAO_BOM",
    "AVALIACAO_ACESSO_REMOTO_OPCAO_LENTO",
    "AVALIACAO_ACESSO_REMOTO_OPCAO_NAO_FUNCIONOU",
    "AVALIACAO_ACESSO_REMOTO_OPCAO_VARIAS_TENTATIVAS",
    "AVALIACAO_ACESSO_REMOTO_OPCAO_PROBLEMAS",
    "AVALIACAO_ACESSO_REMOTO_OPCAO_OUTRO"
  ];

  constructor(
    public modal: NgbActiveModal,
    private formBuilder: UntypedFormBuilder,
    private acessoRemotoService: AcessoRemotoService,
    private toastr: ToastrService,
    public translate: TranslateService,
    private elemRef: ElementRef
  ) {
    this.selector = this.elemRef.nativeElement.tagName.toLowerCase();
  }

  ngOnInit(): void {
    document.getElementsByTagName(this.selector)[0]["style"]["zoom"] = "0.85";
    this.buildForm();
    this.setEditorConfig();
  }

  ngOnDestroy(): void {
    this.newSubs?.unsubscribe();
  }

  buildForm(): void {
    this.avaliacaoForm = this.formBuilder.group({
      nota: ["", Validators.required],
      opcao: ["", Validators.required],
      comentario: ["", Validators.required],
    });
  }

  setEditorConfig(): void {
    this.editorConfig = {
      image: {
        resizeUnit: 'px',
        resizeOptions: [
          { name: 'resizeImage:original', label: 'Original', value: null },
          { name: 'resizeImage:100', label: '100px', value: '100' },
          { name: 'resizeImage:200', label: '200px', value: '200' }
        ]
      },
      placeholder: this.translate.instant('INSIRA_TEXTO_IMAGEM')
    };
  }

  setAvaliacaoValue(valor: number): void {
    this.avaliacaoForm.patchValue({ nota: valor });
  }

  isComentarioValido(): boolean {
    const comentario: string = this.avaliacaoForm.controls.comentario.value;

    if (!comentario) {
      return false;
    }

    const texto = comentario.replace(/<[^>]+>/g, "").replace(/&nbsp;/g, " ").trim();
    return texto.length > 0;
  }

  isSubmitDisabled(): boolean {
    return (
      this.isSaving ||
      !this.avaliacaoForm.controls.nota.value ||
      !this.avaliacaoForm.controls.opcao.value ||
      !this.isComentarioValido()
    );
  }

  avaliar(): void {
    if (this.isSubmitDisabled()) {
      this.avaliacaoForm.markAllAsTouched();
      return;
    }

    const clienteId =
      this.dispositivo?.cliente_id ||
      this.dispositivo?.cliente?.id ||
      this.dispositivo?.cliente?.cliente_id;

    if (!clienteId) {
      this.toastr.show(
        this.translate.instant("AVALIACAO_ACESSO_REMOTO_CLIENTE_INVALIDO"),
        "",
        environment.toastrConfig("warning")
      );
      return;
    }

    const comentarioFinal: string = this.avaliacaoForm.controls.comentario.value || "";

    const opcaoSelecionadaKey = this.avaliacaoForm.controls.opcao.value;

    const payload = {
      cliente_id: clienteId,
      nota: this.avaliacaoForm.controls.nota.value,
      opcao: opcaoSelecionadaKey,
      comentario: comentarioFinal,
    };

    this.isSaving = true;
    this.newSubs = this.acessoRemotoService.avaliarAcessoRemoto(payload).subscribe(
      () => {
        this.toastr.show(this.translate.instant("SALVO_SUCESSO"), "", environment.toastrConfig("success"));
        this.modal.close(true);
      },
      (error) => {
        console.error("avaliarAcessoRemoto", error);
        this.toastr.show(this.translate.instant("AVALIACAO_ACESSO_REMOTO_ERRO_SALVAR"), "", environment.toastrConfig("warning"));
        this.isSaving = false;
      }
    );
  }
}
